module.exports = __webpack_public_path__ + "static/img/master-card.cf017c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/billing/master-card.png
// module id = gsm2
// module chunks = 1